<template>
    <Select
        v-if="islabel"
        v-model="str"
        :transfer="transfer"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="placeholder"
        :loading="loading"
        filterable
        remote
        :remote-method="remoteMethod"
        @click.native="clickElement"
        @on-change="callback"
        @on-clear="empty"
    >
        <Option
            v-for="item in list"
            :value="item[type.label]"
            :key="item[type.label]"
        >{{ item[type.label] }}</Option>
    </Select>
    <Select
        v-else-if="returnItem"
        v-model="str"
        :transfer="transfer"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="placeholder"
        :loading="loading"
        filterable
        remote
        :remote-method="remoteMethod"
        @click.native="clickElement"
        @on-change="callback"
        @on-clear="empty"
    >
        <Option
            v-for="item in list"
            :value="item[type.label]"
            :key="item[type.label]"
        >{{ item[type.label] }}</Option>
    </Select>
    <Select
        v-else
        v-model="str"
        @input="change($event)"
        :transfer="transfer"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="placeholder"
        :loading="loading"
        filterable
        remote
        :remote-method="remoteMethod"
        @click.native="clickElement"
        @on-change="callback"
        @on-clear="empty"
    >
        <Option
            v-for="item in list"
            :value="item[type.value]"
            :key="item[type.value]"
        >{{ item[type.label] }}</Option>
    </Select>
</template>
<script>
export default {
    name: 'remoteSelect',
    props: {
        value: {
            type: [String, Number, Array],
            default: ''
        },
        type: {
            type: Object,
            default: () => ({ label: 'CHORGNAME', value: 'CHORGCODE' })
        },
        queryFont: {
            type: String,
            default: 'buySellName'
        },
        size: {
            type: String,
            default: 'default'
        },
        clearable: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '请输入并选择'
        },
        defaultUrl: {
            type: String,
            default: ''
        },
        remoteUrl: {
            type: String,
            default: ''
        },
        transfer: {
            type: Boolean,
            default: true
        },
        islabel: {
            type: Boolean,
            default: false//不取value值，取label值
        },
        returnItem: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            str: '',
            list: []
        }
    },
    watch: {
        'value' (value) {
            this.getVal(value)
        }
    },
    mounted () {
        this.getVal(this.value);
        this.getDefaultOptions()
    },
    methods: {
        getVal (val) {
            this.str = val;
            if (!val) this.getDefaultOptions();
        },
        getDefaultOptions () {
            this.$ajax.post(this.defaultUrl).then(data => {
                if (data.status == this.$ajax.HTTP_S) {
                    this.list = data.result;
                }
            });
        },
        remoteMethod (query) {
            console.log(query);
            if (query && query.length >= 4) {
                this.$ajax.post(this.remoteUrl, { [this.queryFont]: query }).then(data => {
                    if (data.status == this.$ajax.HTTP_S) {
                        this.list = data.result;
                    }
                });
            } else {
                this.list = [];
            }
        },
        change (val) {
            this.$emit('input', val)
        },
        callback (v) {
            if (this.islabel == true) { this.$emit('callback', v); return }
            if (this.returnItem == true && v) {
                const i = this.list.findIndex(item => item[this.type.label] === v);
                this.$emit('callback', this.list[i]);
            }
            if (v) {
                const i = this.list.findIndex(item => item[this.type.value] === v);
                this.$emit('callback', this.list[i]);
            } else {
                this.$emit('callback', v);
            }
        },
        //  清空时重新获取列表
        empty () {
            this.getDefaultOptions('')
        },
        clickElement (e) {
            e.target.focus()
        }
    }
}
</script>
<style scoped>
.ivu-select-single >>> .ivu-select-selection {
    margin-top: 1px;
    height: 32px;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/inc/remoteSelect/remoteSelect.vue